<script>
export default {
    name: "EmployeeModal",
    data() {
        return {
            submitted: false,
            tableData: [],
            modalTitle: "",
            totalRows: 1,
            currentPage: 1,
            perPage: 5,
            pageOptions: [5, 10, 25, 50, 100],
            filter: null,
            filterOn: [],
            sortBy: "employee",
            sortDesc: false,
            fields: [
                {
                    key: "employee",
                    sortable: true,
                    label: "Employee",
                    thStyle: { width: "85%" },
                },
            ],
            indexSelected: -1,
            tableBusy: false,
            multiple: false,
            selectedCampus: this.$store.state.data.selectedCampus.id,
            selectedUsers: [],
            hideCampusSelection: false,
            searchData: [],
            searchAll: false,
            searchFilter: '',
        };
    },
    computed: {
        selectedEmployees() {
            return this.tableData.filter((row) => row.checkEmployee);
        },
        rows() {
            if(this.filter && this.filter.length > 0){
                return this.totalRows;
            }
            return this.tableData.length;
        },
    },
    methods: {
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        dropData(data) {
            if(this.multiple){
                data[0].checkEmployee = !data[0].checkEmployee;
            }else{
                this.$emit("dropData", data[0]);
                this.$bvModal.hide("employee-modal");
            }
        },
        async multipleSelection(row){
            this.hideCampusSelection = false;
            this.selectedUsers = row;
            this.selectedCampus = this.$store.state.data.selectedCampus.id;
            this.searchAll = false;
            this.tableBusy = true;
            this.searchFilter = '';
            await this.$store
            .dispatch("employee/GetEmployeeByCampus", this.$store.state.data.selectedCampus.id)
            .then((res) => {
                let users = [];
                res.data.forEach(item => {
                    item.checkEmployee = false;
                    if(!row.technicalUsers.find(y => y.applicationUser.employeeId == item.id)){
                        users.push(item)
                    }
                })
                this.tableData = users;
            })
            .catch(() => {
                this.showToast("Something went wrong!","error");
            });
            this.multiple = true;
            this.tableBusy = false;
        },
        async getSingleSelection(type, hideCampusSelection){
            this.hideCampusSelection = hideCampusSelection ? hideCampusSelection : false;
            this.multiple = false;
            this.selectedCampus = this.$store.state.data.selectedCampus.id;
            this.searchAll = false;
            this.searchFilter = '';
            if(type === 'delivery unit'){
                this.tableBusy = true;
                await this.$store
                    .dispatch("employee/GetEmployeeByDU", this.$store.state.data.selectedDU.id)
                    .then((res) => {
                        this.tableData = res.data;
                    })
                    .catch(() => {
                        this.showToast("Something went wrong!","error");
                    });
                this.tableBusy = false;
            }else{
                this.tableBusy = true;
                await this.$store
                    .dispatch("employee/GetEmployeeByCampus", this.$store.state.data.selectedCampus.id)
                    .then((res) => {
                        this.tableData = res.data;
                    })
                    .catch(() => {
                        this.showToast("Something went wrong!","error");
                    });
                this.tableBusy = false;
            }
        },
        async getAllSelections(){
            this.multiple = false;
            this.hideCampusSelection = true;
            this.tableBusy = true;
            this.searchAll = true;
            this.searchFilter = '';
            await this.$store
                .dispatch("employee/GetEmployee", this.$store.state.data.agency.id)
                .then((res) => {
                    this.searchData = res.data;
                })
                .catch(() => {
                    this.showToast("Something went wrong!","error");
                });
            this.tableBusy = false;
        },
        proceedChecking(selected){
            this.$emit("dropMultiple", selected);
            this.$bvModal.hide("employee-modal");
        },
        async changeCampus(){
            if(this.multiple){
                this.tableBusy = true;
                await this.$store
                .dispatch("employee/GetEmployeeByCampus", this.selectedCampus)
                .then((res) => {
                    let users = [];
                    res.data.forEach(item => {
                        item.checkEmployee = false;
                        if(!this.selectedUsers.technicalUsers.find(y => y.applicationUser.employeeId == item.id)){
                            users.push(item)
                        }
                    })
                    this.tableData = users;
                })
                .catch(() => {
                    this.showToast("Something went wrong!","error");
                });
                this.tableBusy = false;
            }else{
                this.tableBusy = true;
                await this.$store
                    .dispatch("employee/GetEmployeeByCampus", this.selectedCampus)
                    .then((res) => {
                        this.tableData = res.data;
                    })
                    .catch(() => {
                        this.showToast("Something went wrong!","error");
                    });
                this.tableBusy = false;
            }
        },
        searchAllData(){
            if(this.searchFilter.length > 0){
                this.tableData = this.searchData.filter(x => x.lastName.toLowerCase().includes(this.searchFilter.toLowerCase()));
            }else{
                this.tableData = [];
            }
        }
    },
};
</script>

<template>
    <b-modal
        id="employee-modal"
        title="Employee List"
        size="lg"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
    >
        <div class="row mt-1">
            <!-- Search -->
            <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter" v-if="searchAll">
                    <form @submit.prevent="searchAllData">
                        <label class="d-inline-flex align-items-center">
                            Search:
                            <b-form-input
                                autocomplete="off"
                                v-model="searchFilter"
                                type="search"
                                placeholder="Search Lastname..."
                                class="form-control mx-2 w-75"
                            ></b-form-input>
                            <b-form-select
                                class="form-select w-25"
                                v-model="perPage"
                                :options="pageOptions"
                            ></b-form-select>
                        </label>
                    </form>
                </div>
                <div id="tickets-table_filter" class="dataTables_filter" v-else>
                    <label class="d-inline-flex align-items-center">
                        Search:
                        <b-form-input
                            autocomplete="off"
                            v-model="filter"
                            type="search"
                            placeholder="Search..."
                            class="form-control mx-2 w-75"
                        ></b-form-input>
                        <b-form-select
                            class="form-select w-25"
                            v-model="perPage"
                            :options="pageOptions"
                        ></b-form-select>
                    </label>
                </div>
            </div>
            <div class="col-md-6" v-if="!hideCampusSelection && $store.state.decrypt.campusAccessList().length > 1">
                <select name="campusAccess" class="form-select" @change="changeCampus" v-model="selectedCampus">
                    <option v-for="campus in $store.state.decrypt.campusAccessList()" :value="campus.Id" :key="campus.Id">{{campus.CampusName}}</option>
                </select>
            </div>
            <!-- End search -->
        </div>
        <div class="table-responsive mb-0">
            <b-table
                class="datatables"
                :items="tableData"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                :busy="tableBusy"
                @filtered="onFiltered"
                bordered
                outlined
                hover
                striped
                show-empty
                :select-mode="multiple ? 'range' : 'single'"
                selectable
                @row-selected="dropData"
            >
                <template #empty="scope">
                    <div class="text-center" v-if="!searchAll">{{ scope.emptyText }}</div>
                    <div class="text-center text-warning" v-else>Kindly type the lastname in the search input and then hit enter.</div>
                </template>
                <template #table-busy>
                    <div
                        class="d-flex justify-content-center align-items-center"
                    >
                        <div class="preloader-component me-2">
                            <div class="status">
                                <div class="spinner-chase w-20px h-20px">
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                </div>
                            </div>
                        </div>
                        <strong>Loading...</strong>
                    </div>
                </template>
                <template #cell(employee)="row">
                    <div class="d-flex align-items-center">
                        <div>
                            <div class="mt-1">
                                <div
                                    v-if="multiple"
                                    class="
                                        form-check
                                        form-checkbox-outline
                                        form-check-success
                                        mb-0
                                    "
                                >
                                    <input
                                        type="checkbox"
                                        :id="`emp-${row.item.id}`"
                                        checked="checked"
                                        class="
                                            form-check-input
                                        "
                                        v-model="
                                            row.item.checkEmployee
                                        "
                                    /><label
                                        :for="`emp-${row.item.id}`"
                                        class="
                                            form-check-label
                                        "
                                    >
                                        <h5 class="mb-0">
                                            {{
                                                row.item.lastName
                                                    .charAt(0)
                                                    .toUpperCase() +
                                                row.item.lastName.slice(
                                                    1
                                                )
                                            }},
                                            {{
                                                row.item.firstName
                                                    .charAt(0)
                                                    .toUpperCase() +
                                                row.item.firstName.slice(
                                                    1
                                                )
                                            }}
                                            {{
                                                row.item.middleName
                                                    ? `${row.item.middleName
                                                            .charAt(0)
                                                            .toUpperCase()}.`
                                                    : ""
                                            }}
                                        </h5>
                                    </label>
                                </div>
                                <h5 class="mb-0" v-if="!multiple">
                                    {{
                                        row.item.lastName
                                            .charAt(0)
                                            .toUpperCase() +
                                        row.item.lastName.slice(
                                            1
                                        )
                                    }},
                                    {{
                                        row.item.firstName
                                            .charAt(0)
                                            .toUpperCase() +
                                        row.item.firstName.slice(
                                            1
                                        )
                                    }}
                                    {{
                                        row.item.middleName
                                            ? `${row.item.middleName
                                                    .charAt(0)
                                                    .toUpperCase()}.`
                                            : ""
                                    }}
                                </h5>
                            </div>
                            <div>{{ row.item.position }}</div>
                            <i>{{ row.item.email }}</i>
                        </div>
                    </div>
                </template>
            </b-table>
        </div>
        <div class="row">
            <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                    <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                        ></b-pagination>
                    </ul>
                </div>
            </div>
        </div>
        <div class="position-fixed fix-top-middle" v-if="multiple && selectedEmployees.length > 0">
            <button type="button" class="btn btn-success text-truncate" @click="proceedChecking(selectedEmployees)">Proceed with {{selectedEmployees.length}} selected Employees</button>
        </div>
    </b-modal>
</template>
